import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  section: {
    marginBottom: theme.spacing(2),
  },
  sectionTitle: {
    fontWeight: 600,
    marginBottom: theme.spacing(1),
  },
  row: {
    display: 'flex',
    marginBottom: theme.spacing(0.5),
  },
  label: {
    fontWeight: 600,
    width: 150,
    flexShrink: 0,
    color: theme.palette.text.secondary,
  },
  value: {
    color: theme.palette.text.primary,
  },
  assetList: {
    paddingLeft: theme.spacing(2),
    margin: 0,
  },
}));

export default useStyles;
